import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Button, Glyphicon } from "react-bootstrap";
import BaseUrl from "../../../Stores/DataStore/Enums/BaseUrl";
import axios from "axios";

class MailPassword extends Component {
  constructor(props) {
    super(props);

    this.state = { buttonText: "Send password link by mail", glyph: "envelope", disabled: false };

    this.onMailSuccesfullySend = this.onMailSuccesfullySend.bind(this);
    this.onMailFailedToSend = this.onMailFailedToSend.bind(this);
  }

  onMailSuccesfullySend(response) {
    this.setState({ buttonText: "Email sent!", glyph: "ok", disabled: true });
  }

  onMailFailedToSend(error) {
    this.props.onFailure(error);
  }

  async sendMail() {
    const { stores, user } = this.props;

    const baseUrl = new BaseUrl();
    const url = baseUrl.SERVERURL + "/api/public/mail-new-account.php";

    await axios
      .post(
        url,
        JSON.stringify({
          emailRecipient: user.Email,
          emailSender: stores.currentUser.user.Email,
        })
      )
      .then(
        function (response) {
          this.onMailSuccesfullySend(response);
        }.bind(this)
      )
      .catch(
        function (error) {
          if (error) {
            console.log(error);
            console.log(error.message);
          }
          this.onMailFailedToSend(error);
        }.bind(this)
      );
  }

  render() {
    return (
      <div>
        <Button type="button" bsStyle="info" onClick={this.sendMail.bind(this)} disabled={this.state.disabled}>
          <Glyphicon glyph={this.state.glyph} />
          <span> {this.state.buttonText}</span>
        </Button>
      </div>
    );
  }
}

export default inject("stores")(observer(MailPassword));



// WEBPACK FOOTER //
// ./src/Core/Components/Buttons/MailPassword.js